import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-request-default',
  templateUrl: './request-default.component.html',
  standalone: false,
})
export class RequestDefaultComponent implements OnDestroy {
  ngOnDestroy() {
    sessionStorage.removeItem('savedFilters');
  }
}
